import {createSHA1} from "hash-wasm";

export const getHashForFile = async (file:File):Promise<string|null> => {
    try{
        const hasher = await createSHA1()
        const reader = file.stream().getReader();

        let readerIsDone = false;
        while (!readerIsDone){
            const { done, value } = await reader.read()

            if (value !== undefined) hasher.update(value)

            readerIsDone = done;
        }

        reader.releaseLock()

        return hasher.digest();
    }
    catch(e){
        console.log(e)
        return null;
    }
}